import { FC } from 'react';

export const GiftDepositInfoBox: FC = function GiftDepositInfoBox() {
  return (
    <div className="bg-white border-t p-4">

      {/* 전화주문 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100">
            <svg className="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
          <div>
            <p className="text-xs text-gray-500">전화주문 및 안내</p>
            <a href="tel:18006987" className="text-sm font-bold">
              1800-6987
            </a>
          </div>
        </div>
        <p className="text-xs text-gray-400">09:00 - 18:00</p>
      </div>
     
      {/* 구분선 */}
      <div className="my-3 border-t border-gray-200" />

       {/* 입금계좌 */}
       <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-100">
            <svg className="h-4 w-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
            </svg>
          </div>
          <div>
            <p className="text-xs text-gray-500">입금계좌</p>
            <p className="text-sm font-bold">기업은행 137-115848-04-019</p>
          </div>
        </div>
        <p className="text-xs text-gray-400">(주)가온프라임</p>
      </div>

    </div>
  );
};
